/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2025 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { useAppDispatch } from "@src/config/store";
import React, { FC } from "react";
import { IRootState } from "@src/config/reducers";
import { useSelector } from "react-redux";
import { LaddaButton } from "@advapacs/common";
import { UnauthenticatedActions } from "./ducks/slices";
import SuccessIcon from "@advapacs/common/src/assets/icons/ic-success.png";

export const VerifyActivitySuccess: FC = () => {
  const dispatch = useAppDispatch();
  const { loading } = useSelector(
    (state: IRootState) => state.unAuthenticatedReducer
  );

  const submit = async () => {
    dispatch(
      UnauthenticatedActions.getOTPTypeResponseSuccessFromSuspiciousActivitySuccess()
    );
    dispatch(UnauthenticatedActions.clearSuspicousActivity());
  };

  return (
    <form autoComplete="off">
      <img src={SuccessIcon} className="m-r-xxs p-b-lg" />
      <div className="w-100">
        <div className="col-lg-12 col-xs-12">
          <h5 className="m-b-sm">Verification Successful</h5>
        </div>

        <div className="col-lg-12">
          <p className="d-inline">
            You will receive an OTP via selected method.
          </p>
        </div>

        <div className="col-lg-12 m-t-lg w-100">
          <LaddaButton
            loading={loading}
            type="button"
            className="btn btn-verify btn-secondary"
            disabled={false}
            btnName="Continue"
            onClickHandler={submit}
          />
        </div>
      </div>
    </form>
  );
};
